var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PortalModuleExternalNonBlankCard',{attrs:{"title":"Konstituering","description":"Menighedsrådets valgte og fødte medlemmer samt konstitution.","button-text":"Gå til konstituering","icon-class":"fad fa-user-friends","card-active":true,"footer":"&nbsp;","link":`${_vm.konstitueringBaseUrl}/${_vm.midFromUrl}`}})
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }